<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th class="td-sm"></th>
                <th>#</th>
                
                <th>Tipo</th>
                <th>Usuario Licencia</th>
                <th>F. Activacion</th>
                <th>F. Vencimiento</th>
            
                <th class="text-center">Acciones</th>
            </template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index" >
                    <td class="td-sm"></td>
					<td>{{ (index+1) }}</td>

                    <td>{{lista.TipoLicencia}}</td>
                    <td>{{lista.UsuarioLicencia}}</td>
                    <td>{{lista.FechaActivacion}}</td>
                    <td>{{lista.FechaVencimiento}}</td>
               
					<td>
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdLicenciaEquipo" :pEmitSeccion="ConfigList.EmitSeccion">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"/>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :poEquipo="localObjEquipo"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import CList from "../../../components/CList.vue";
import CSinRegistros from "../../../components/CSinRegistros.vue";
import CBtnAccion from "../../../components/CBtnAccion.vue";
import CModal from "../../../components/CModal.vue";
import Form from '@/views/catalogos/equiposlicencias/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionEquipolicencia';

export default {
    name: 'ListaEquipolicencia',
    props:['pObjEquipo'],
    components: {
        Form,
        CModal,
        CSinRegistros,
        CBtnAccion,
        CList
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado Licencias',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                TitleFirst:'Equipos',
                EmitSeccion: EmitEjecuta,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle:  "Formulario Licencias Equipo",
                ModalNameId: 'ModalForm',
                EmitSeccion:  EmitEjecuta,
                ModalSize: 'md'
            },

            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            localObjEquipo: {},
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("equiposlicencias",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdEquipo: this.localObjEquipo.IdEquipo,
                }
            }).then((res) => {
                this.ListaArrayRows   = res.data.data.data;
                this.Filtro.Pagina    = res.data.data.current_page;
                this.Filtro.TotalItem = res.data.data.total;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },

        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('equiposlicencias/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },

        Regresar(){
            this.$router.push({name:'equiposmantenimiento',params:{}});
        },
    },
    created()
    {
        if(this.pObjEquipo != undefined){
            sessionStorage.setItem('objEquipo',JSON.stringify(this.pObjEquipo));
        }

        this.localObjEquipo = JSON.parse(sessionStorage.getItem('objEquipo'));
        this.ConfigList.Title = this.ConfigList.Title+': '+this.localObjEquipo.Marca +' '+this.localObjEquipo.NoSerie;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
